/* Sequoia Fitness | Website: https://www.sequoia.fitness | Author: Ali Hosseini | Copyright (c) 2026 sequoia.fitness. All rights reserved. */
/* Designed and developed by Pouria Shabani | https://linkedin.com/in/pouriashabani */

import { createElement } from 'react'

const APP_ORDER = 'https://app.sequoia.fitness/new-order'

function href(h) {
  if (!h) return h
  if (/order-program/.test(h)) return APP_ORDER
  return h
}

export default function Tree({ node }) {
  if (node === null || node === undefined) return null
  if (typeof node === 'string') return node
  const { t, c, a, k } = node
  const props = {}
  if (c && c.length) props.className = c.join(' ')
  if (t === 'img') {
    return <img {...props} src={a.src} alt={a.alt || ''} loading="lazy" decoding="async" />
  }
  if (t === 'a') {
    props.href = href(a.href)
    if (/^https?:/.test(props.href || '')) {
      props.target = '_blank'
      props.rel = 'noopener'
    }
  }
  if (t === 'br') return <br />
  const kids = (k || []).map((x, i) => <Tree node={x} key={i} />)
  return createElement(t, props, ...kids)
}

export function Inline({ nodes }) {
  return (nodes || []).map((n, i) => <Tree node={n} key={i} />)
}
